export default __webpack_public_path__ + "static/media/team3.1d5f94b2.png";